import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import liff from '@line/liff';


import { Box, Button, Link } from '@mui/material';
import { useDocument } from 'react-firebase-hooks/firestore';
import { inbodyUrls } from '../constants';
import UserService from '../services/user.service';
import UserActions from '../sections/selfservice/UserActions';

import { isLocalhost } from '../App';

const liffId = '1656457313-XxZvbOQQ' // process.env.REACT_APP_LIFF_ID

function logOut() {
  liff.logout()
  // setSignedIn(false)
  window.location.reload()
}

function logIn() {
  liff.login({ redirectUri: window.location.href })
}

async function getLineProfile() {
  const profile = await liff.getProfile()
  // document.getElementById("pictureUrl").style.display = "block"
  // document.getElementById("pictureUrl").src = profile.pictureUrl
  return profile
}

Selfservice.propTypes = {
  userprofile: PropTypes.object
};

export default function Selfservice({ userprofile = {} }) {

  // const { pathname } = useLocation();
  const [profile, setProfile] = useState(userprofile);
  const [liffInfo, setLiffInfo] = useState({})
  
  // const [user, setUser] = useState(profile);
  const [user, loadingUser, errorGetUser] = useDocument(UserService.user('abc'));
  const params = useParams();
  const { service } = params;

  const [extraui, setExtraui] = useState(<></>);


  // const [scanning, setScanning] = useState(false);
  // const [log, setLog] = useState("LOG appears here");

  useEffect(() => {

    const osType = liff.getOS()
    // window.alert(`เปิด InBody สำหรับ ${ osType}`)
    if (service && service === 'inbody' && osType) {
      setExtraui(<Button variant='contained' color='warning' onClick={() => window.open(inbodyUrls[osType], '_blank')}>เปิดแอป Inbody</Button>)

      if (osType === 'android') {
        window.open(inbodyUrls[osType], '_blank')
      } else {
        liff.openWindow({ url: inbodyUrls[osType], external: true })
      }
      setTimeout(() => {
        liff.closeWindow();
      }, 1000);
      return
    }


    // let user
    if (isLocalhost) {

      const profile = {
        userId: 'abc',
        displayName: 'Chaloemphol',
        statusMessage: `ev’ry moment new`,
        pictureUrl: '/assets/images/avatars/avatar_2.jpg',
      }
      setProfile(profile)
      // })
    }

    (async () => {

      //   if (isLocalhost) return
      await liff.init({ liffId, withLoginOnExternalBrowser: false })

      if (!liff.isInClient() && !liff.isLoggedIn()) {
        liff.login()
      }
      await getLineProfile()
        .then(data => {
          setProfile(data)
        })
    })()

  }, [service]);

  useEffect(() => {
    console.log('errorGetUser', errorGetUser);
    console.log('profile', profile);
  }, [profile, errorGetUser])

  useEffect(() => {
    (async () => {

      await liff.getFriendship()
        .then(r => setLiffInfo(i => ({
          ...i,
          'isInClient': liff.isInClient(),
          'getVersion': liff.getVersion(),
          'getLineVersion': liff.getLineVersion(),
          'friendFlag': r.friendFlag
        })))
    })()

  }, [])

  const useraction = useMemo(() => {
    if (!profile || !profile.userId || loadingUser) return <></>;
    return (<UserActions profile={{ ...user.exists() ? user.data() : {}, ...profile }} setProfile={setProfile} />)
  }, [loadingUser, profile, user])

  if (service) return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    p: 1,
    m: 1, width: '100%'
  }}>
    {extraui}
    <Button onClick={() => liff.closeWindow()}>ปิดหน้าต่างนี้</Button></Box>
  return useraction;
}